import { gql } from "@apollo/client";

export const APP_VERSION_QUERY = gql`
  query appVersion {
    appVersion {
      version
      date
    }
  }
`;

export const DATABASE_VERSION_QUERY = gql`
  query databaseVersion {
    databaseVersion {
      version
    }
  }
`;
